if (typeof TooltipNotice !== 'function') {
class TooltipNotice extends HTMLElement {
	connectedCallback() {
		document.querySelectorAll('[data-tooltip]').forEach((item) => {
			item.addEventListener('mouseover', () => {
				this.showTooltip(item);
			});

			item.addEventListener('mouseout', () => {
				this.hideTooltip();
			});
		});

		document.addEventListener('tooltip:refresh', () => {
			document.querySelectorAll('[data-tooltip]').forEach((item) => {
				item.addEventListener('mouseover', () => {
					this.showTooltip(item);
				});
	
				item.addEventListener('mouseout', () => {
					this.hideTooltip();
				});
			});
		});
	}

	showTooltip(parent) {
		const currentPosition = parent.getBoundingClientRect();
		
		this.style.display = 'block';
		this.innerText = parent.dataset.tooltip;

		const tooltipWidth = this.offsetWidth;
		const adjust = 3;

		this.style.top = `${currentPosition.top + document.documentElement.scrollTop - this.offsetHeight - 10}px`;
		this.style.left = `${currentPosition.left + adjust+ (currentPosition.width / 2) - (tooltipWidth / 2)}px`;
	}

	hideTooltip() {
		this.style.display = 'none';
	}
}

	if (!customElements.get('tooltip-notice')) {
		customElements.define('tooltip-notice', TooltipNotice);
	}
}